import { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full p-8 bg-white rounded-xl shadow-medium text-center">
            <AlertTriangle className="h-16 w-16 text-error mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Villa kom upp
            </h1>
            <p className="text-gray-600 mb-6">
              Eitthvað fór úrskeiðis. Vinsamlegast reyndu aftur.
            </p>
            {this.state.error && import.meta.env.DEV && (
              <pre className="text-left text-xs bg-gray-100 p-4 rounded mb-4 overflow-auto">
                {this.state.error.toString()}
              </pre>
            )}
            <button
              onClick={this.handleReload}
              className="px-6 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-secondary transition-colors"
            >
              Endurhlaða síðu
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
